import axiosInstance from "./axios";
import { AbstractModel } from "./models/abstractProduct.models";
import {
  CreatePackageRowPayload,
  PackageRow,
  UpdatePackageRowPayload,
} from "./models/packageRow.models";

const apiUrl = import.meta.env.VITE_BACKEND_API_URL;

export const fetchPackageRow = async (
  bearerToken: string,
  packageRowIdentifier: string | null
): Promise<PackageRow> => {
  try {
    const response = await axiosInstance.get(
      `${apiUrl}/Products/packageRows/${packageRowIdentifier}`,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch package row:", error);
    throw error;
  }
};

export const createNewPackageRow = async (
  bearerToken: string,
  payload: CreatePackageRowPayload
): Promise<PackageRow> => {
  try {
    const response = await axiosInstance.post(
      `${apiUrl}/Products/${payload.companyId}/packageRows`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to create package row:", error);
    throw error;
  }
};

export const updatePackageRow = async (
  bearerToken: string,
  payload: UpdatePackageRowPayload
): Promise<PackageRow> => {
  try {
    const response = await axiosInstance.patch(
      `${apiUrl}/Products/${payload.companyId}/packageRows`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch all abstract products:", error);
    throw error;
  }
};
